import React, { useContext } from "react";

import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { SessionContext } from "../../context/SessionContext";

const useStyles = makeStyles({
  copyFields: {
    background: "#171F31",
    borderRadius: "2px",
    color: "#FFF",
    fontSize: "0.8em",
    height: "50px",
    marginTop: "5px",
    padding: "10px 20px",
    width: "350px"
  },
  dialogTitle: {
    background: "#43475B",
    fontSize: "40px",
    fontWeight: "bold",
    padding: "1em 2em 1em 1.5em",
    textAlign: "left",
    "@media only screen and (max-width: 650px)": {
      fontSize: "30px"
    },
    "@media only screen and (max-width: 450px)": {
      fontSize: "20px"
    }
  },
  title: {
    fontSize: 14
  },
  trialFeaturesList: {
    marging: "0",
    padding: "0"
  },
  trialForm: {
    background: "transparent",
    boxShadow: "none",
    color: "#FFF",
    // height: '50vh',
    textAlign: "left",
    width: "60vw"
  }
});

const TrialAccess = ({ handleClose }) => {
  const classes = useStyles();

  const { currentTrial, setCurrentTrial, userData } = useContext(
    SessionContext
  );

  const handleComplete = () => {
    // TODO: Not sure this next line is necessary
    setCurrentTrial({ ...currentTrial, hasNotStartedAPITrial: false });

    // This one is though
    handleClose();
  };

  return (
    <React.Fragment>
      <DialogTitle
        id="responsive-dialog-title"
        className={classes.dialogTitle}
        disableTypography={true}
      >
        {"Trial now activated!"}
        <Button
          style={{ float: "right", transform: "translate(40px, 0)" }}
          onClick={handleComplete}
        >
          <CloseIcon style={{ color: "#FFF", transform: "scale(1.8)" }} />
        </Button>
      </DialogTitle>
      <DialogContent
        style={{ background: "#33374B", padding: "2em 4em 4em 4em" }}
      >
        <Paper className={classes.trialForm}>
          <Typography
            variant="subtitle1"
            style={{ fontSize: "1.3em", fontWeight: "bold" }}
          >
            Heres the important information
          </Typography>
          <Grid container spacing={10} style={{ padding: "2em 2em 0 0" }}>
            <Grid
              item
              // style={{ width: '25vw' }}
            >
              <Typography variant="subtitle1">API Token</Typography>
              <TextField
                id="api-token"
                color="primary"
                defaultValue={userData.token}
                InputProps={{
                  className: classes.copyFields,
                  disableUnderline: true,
                  readOnly: true
                }}
              />
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#228CBD",
                  borderRadius: "2px",
                  color: "#FFF",
                  display: "block",
                  fontSize: "0.8em",
                  fontWeight: "bold",
                  padding: "0.5em 2.5em 0.5em 2.5em",
                  marginTop: "3vh",
                  textTransform: "none"
                }}
                onClick={() => {
                  navigator.clipboard.writeText(userData.token);
                }}
              >
                Copy Token
              </Button>
            </Grid>
            <Grid item>
              <Typography variant="subtitle1">API Documentation</Typography>
              <TextField
                id="documentation-snippet"
                color="primary"
                defaultValue="docs.sofarocean.com"
                InputProps={{
                  className: classes.copyFields,
                  disableUnderline: true,
                  readOnly: true
                }}
              />
              <Button
                variant="contained"
                style={{
                  backgroundColor: "transparent",
                  border: "3px solid #228CBD",
                  borderRadius: "2px",
                  color: "#FFF",
                  display: "block",
                  fontSize: "0.8em",
                  fontWeight: "bold",
                  padding: "0.5em 2.5em 0.5em 2.5em",
                  marginTop: "3vh",
                  textTransform: "none"
                }}
              >
                <a
                  href="https://docs.sofarocean.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#FFF", textDecoration: "none" }}
                >
                  Read Docs
                </a>
              </Button>
            </Grid>
          </Grid>

          <hr
            style={{
              border: "1px solid #43475B",
              width: "40%",
              margin: "2em 0"
            }}
          />

          <Typography
            variant="subtitle1"
            style={{ fontSize: "1.3em", fontWeight: "bold" }}
          >
            Give the API a try
          </Typography>
          <Grid container spacing={10} style={{ padding: "2em 2em 0 0" }}>
            <Grid
              item
              // style={{ width: '25vw' }}
            >
              <Typography variant="subtitle1">Spotter CURL Snippet</Typography>
              <TextField
                id="curl-snippet"
                color="primary"
                defaultValue={
                  "curl \"https://api.sofarocean.com/api/wave-data?spotterId=SPOTTERID&limit=1\" -H 'token: YOUR_API_TOKEN'"
                }
                InputProps={{
                  className: classes.copyFields,
                  disableUnderline: true,
                  readOnly: true
                }}
              />
              <Button
                variant="contained"
                style={{
                  backgroundColor: "transparent",
                  border: "3px solid #228CBD",
                  borderRadius: "2px",
                  color: "#FFF",
                  display: "block",
                  fontSize: "0.8em",
                  fontWeight: "bold",
                  padding: "0.5em 2.5em 0.5em 2.5em",
                  marginTop: "3vh",
                  textTransform: "none"
                }}
                onClick={() => {
                  navigator.clipboard.writeText(
                    "curl \"https://api.sofarocean.com/api/wave-data?spotterId=SPOTTERID&limit=1\" -H 'token: YOUR_API_TOKEN'"
                  );
                }}
              >
                Copy Snippet
              </Button>
            </Grid>
            <Grid item>
              <Typography variant="subtitle1">
                Operational Wave Forecast CURL Snippet
              </Typography>
              <TextField
                id="standard-read-only-input"
                color="primary"
                defaultValue={
                  "curl https://api.sofarocean.com/api/op-wave-spectra/34.5/200 -H 'token: YOUR_API_TOKEN' -J -O"
                }
                InputProps={{
                  className: classes.copyFields,
                  disableUnderline: true,
                  readOnly: true
                }}
              />
              <Button
                variant="contained"
                style={{
                  backgroundColor: "transparent",
                  border: "3px solid #228CBD",
                  borderRadius: "2px",
                  color: "#FFF",
                  display: "block",
                  fontSize: "0.8em",
                  fontWeight: "bold",
                  padding: "0.5em 2.5em 0.5em 2.5em",
                  marginTop: "3vh",
                  textTransform: "none"
                }}
                onClick={() => {
                  navigator.clipboard.writeText(
                    "curl https://api.sofarocean.com/api/op-wave-spectra/34.5/200 -H 'token: YOUR_API_TOKEN' -J -O"
                  );
                }}
              >
                Copy Snippet
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </DialogContent>
    </React.Fragment>
  );
};

export default TrialAccess;
